export default [
  {
    title: "식품가공용기계(분쇄·절단·혼합·제면기)",
    list: [
      {
        content: "1. 식품가공용기계는 자율안전확인 신고(KCS) 제품이다.\n※ 파쇄·절단·혼합·제면기만 해당",
        isChecked: "",
      },
      {
        content: "2. 접촉에 의한 위험이 미칠 수 있는 동력전달부, 속도조절부, 가공부 등에 안전가드 등이 설치되어 있다.",
        isChecked: "",
      },
      {
        content: "3. 각 부분(방호조치 등)의 고정상태 및 기능 이상 없이 양호하다.\n※ 이물질, 손상부위, 칼날의 마모나 균열, 인터록기능 등의 이상여부",
        isChecked: "",
      },
      {
        content: "4. 비상정지장치가 설치되어 있고 정상적으로 작동된다.",
        isChecked: "",
      },
      {
        content: "5. 이상음 및 이상진동 없이 양호하게 동작한다.",
        isChecked: "",
      },
      {
        content: "6. 절연피복은 손상 없이 양호한 상태이다.",
        isChecked: "",
      },
      {
        content: "7. 전원 플러그·콘센트에는 접지극, 전원선에는 접지선이 내장되어 있다.",
        isChecked: "",
      },
      {
        content: "8. 전원 측에는 감전방지용(정격감도전류 30mA, 작동시간 0.03초 이내) 누전차단기가 설치되어 있고 동작 상태는 양호하다.",
        isChecked: "",
      },
      {
        content: "9. 회전날 등이 있는 기계기구를 사용할 때 헐거운 장갑 착용을 금지*하고 소매나 상의가 늘어지지 않도록 정리한다.\n* 맨손으로 작업하거나 위생 등의 문제로 부득이한 경우, 손에 밀착이 잘 되는 장갑을 착용",
        isChecked: "",
      }, {
        content: "10. 교육 등을 통해 사용자가 사용법을 숙지하고 있다.",
        isChecked: "",
      },
      {
        content: "11. 톱날, 칼날, 회전날 등의 보호커버 및 방호덮개(가드) 등을 벗긴 채로 재료를 투입하지 않는다.",
        isChecked: "",
      },
      {
        content: "12. 기계기구 운전 중에는 점검, 수리 등의 작업을 금지하고 미사용 시는 운전을 정지한다.",
        isChecked: "",
      },
    ],
  },
  {
    title: "가스테이블(가스레인지)",
    list: [
      {
        content: "1. 통풍이 잘되고 인화성 물질이 없는 곳에 설치되어 있다.",
        isChecked: "",
      },
      {
        content: "2. 가스경보기, 자동차단기 등이 설치되고 작동상태는 양호하다.\n* 가스경보기: LNG는 천장으로부터 30cm 이내, LPG는 바닥으로부터 30cm 이내",
        isChecked: "",
      },
      {
        content: "3. 가스관(호스) 및 밸브 등의 설치 및 연결상태는 양호하다.",
        isChecked: "",
      },
      {
        content: "4. 가스테이블이 작업대에서 떨어지지 않도록 설치되었다.",
        isChecked: "",
      },
      {
        content: "5. 가스테이블의 호스는 벽체에 고정되어 있다.",
        isChecked: "",
      },
      {
        content: "6. 가스테이블 앞 작업공간은 충분하게 확보하였다.",
        isChecked: "",
      },
    ],
  },
  {
    title: "조리설비·기구(회전식 국솥, 튀김기 등)",
    list: [
      {
        content: "1. 배관 및 호스에서 가스가 누출되지 않도록 연결상태와 파손여부를 확인한다.",
        isChecked: "",
      },
      {
        content: "2. 가스누출 자동차단기 및 누설경보기 작동테스트를 주기적으로 실시한다.",
        isChecked: "",
      },
      {
        content: "3. 환기시설은 정상적으로 작동한다.",
        isChecked: "",
      },
      {
        content: "4. 조리설비를 고정하는 핸들잠금장치가 정상적으로 설치되어 있다.",
        isChecked: "",
      },
      {
        content: "5. 국솥의 접이식 덮개 모서리부는 날카로운 부분이 없다.",
        isChecked: "",
      },
      {
        content: "6. 국솥의 접이식 덮개 고정상태는 양호하다.",
        isChecked: "",
      },
      {
        content: "7. 국솥의 전면부에 화상방지를 위한 차열판이 설치되어 있다",
        isChecked: "",
      },
    ],
  },
  {
    title: "리프트(간이리프트 등)",
    list: [
      {
        content: "1. 조작스위치는 운반구 외부에 설치되어 있으며, 운반구에 작업자 탑승을 금지한다.",
        isChecked: "",
      },
      {
        content: "2. 비상정지장치는 돌출형(적색) 구조로 적합한 위치에 설치되고 정상 기능을 유지하고 있다.",
        isChecked: "",
      },
      {
        content: "3. 버튼의 운전스위치는 권상, 권하의 방향표시와 운반구의 상하작동이 일치한다.",
        isChecked: "",
      },
      {
        content: "4. 운반구 외부에 부착된 리미트 스위치는 변형 등이 없이 견고하게 설치되어 있다.",
        isChecked: "",
      },
      {
        content: "5. 고정볼트 등이 확실히 고정되고 풀림·변형이 없다.",
        isChecked: "",
      },
      {
        content: "6. 적재하중이 0.5톤 이상이고, 운행경로(높이)가 3m를 초과하는 리프트는 정기적으로 안전검사를 받고 있다.",
        isChecked: "",
      },
      {
        content: "7. 건물 각 층의 승강로 주위에 방호울(높이 1.8m 이상)이 설치되어 있으며, 변형·손상 등이 없다.",
        isChecked: "",
      },
      {
        content: "8. 화물반입구에 안전문이 설치되어 있으며 연동(인터록)장치는 정상적으로 기능이 유지되고 있다.",
        isChecked: "",
      },
      {
        content: "9. 수리·점검 시 주전원을 차단하고, “점검 중 조작금지” 표지를 게시하고 있다.",
        isChecked: "",
      },
      {
        content: "10. 운반구 전면 등 작업자가 보기 쉬운 곳에 정격하중, 운전속도, 경고표시 등을 표시하였다.",
        isChecked: "",
      },
      {
        content: "11. 달기기구용 와이어로프에 소선이 끊어짐이 없으며 심하게 변형되거나 부식된 곳이 없다.",
        isChecked: "",
      },
      {
        content: "12. 달기기구용 체인에 심한 균열 또는 변형이 없다.",
        isChecked: "",
      },
      {
        content: "13. 조작스위치는 승강로 외부의 안전한 위치에 설치되어 있다.",
        isChecked: "",
      },
      {
        content: "14. 운반 시 운반구의 출입문을 닫고 운행하고 있다.",
        isChecked: "",
      },
    ],
  },
  {
    title: "식기세척기",
    list: [
      {
        content: "1. 식기세척기의 컨베이어 벨트에 작업자의 손이 말릴 위험은 없다.",
        isChecked: "",
      },
      {
        content: "2. 식기세척기에 비상정지 스위치, 리미트 스위치 등 안전장치가 설치되었고, 정상작동한다.",
        isChecked: "",
      },
      {
        content: "3. 접지 및 누전차단기를 설치하고, 정기적으로 절연 측정 및 누전차단기 작동점검을 실시한다.",
        isChecked: "",
      },
      {
        content: "4. 식기세척기 측면 도어 고정장치는 양호하다.",
        isChecked: "",
      },
      {
        content: "5. 식기 이송 컨베이어의 속도는 일정하게 유지가 되고 있다.",
        isChecked: "",
      },
      {
        content: "6. 식기세척기 내 증기는 근로자 방향으로 배출되지 않도록 한다.",
        isChecked: "",
      },
      {
        content: "7. 식기세척기의 철재 외함 모서리 등 찔릴 위험이 있는 곳에 커버를 설치하였다.",
        isChecked: "",
      },
      {
        content: "8. 식기세척기 주변에 물기가 없고, 정리정돈 상태는 양호하다.",
        isChecked: "",
      },
    ],
  },
  {
    title: "배기후드",
    list: [
      {
        content: "1. 배기후드와 덕트 속 기름기 등 이물질을 정기적으로 제거한다.",
        isChecked: "",
      },
      {
        content: "2. 배기후드 청소 시 전용 청소용구 및 안전한 작업발판을 사용한다.(2인 1조 작업 실시)",
        isChecked: "",
      },
      {
        content: "3. 조리실 내 조리흄이 발생하지 않도록 배기후드의 성능을 정기적으로 확인한다.",
        isChecked: "",
      },
      {
        content: "4. 배기팬 등 접지 실시 및 누전차단기 작동 여부를 확인한다.",
        isChecked: "",
      },
      {
        content: "5. 배기팬 등 회전체 접근을 금지하고, 회전체 접촉방지용 가드 등이 설치되었다.",
        isChecked: "",
      },
      {
        content: "6. 정비 및 청소 등 작업 시 전원을 차단하고 회전체가 정지된 것을 확인한 후 ‘작업중’임을 표시한다.",
        isChecked: "",
      },
    ],
  },
  {
    title: "이륜차",
    list: [
      {
        content: "1. 사용신고필증, 등록번호판 구비 및 보험에 가입되어 있다.",
        isChecked: "",
      },
      {
        content: "2. 전조등, 제동등, 후미등, 후사경 또는 제동장치는 모두 정상적으로 작동한다.",
        isChecked: "",
      },
      {
        content: "3. 1년마다 정기적으로 안전점검을 받는다.",
        isChecked: "",
      },
      {
        content: "4. 이륜차 면허증 미소지자는 이륜차 운행을 금지한다.",
        isChecked: "",
      },
      {
        content: "5. 운행 전 핸들, 타이어, 머플러 등에 이상이 없는지 확인한다.",
        isChecked: "",
      },
      {
        content: "6. 이륜차를 운행하는 근로자에게 승차용 안전모를 지급하여 착용토록 하고 있다.",
        isChecked: "",
      },
      {
        content: "7. 이륜차를 운행하는 근로자가 음주, 과로 시 운전을 금지한다.",
        isChecked: "",
      },
      {
        content: "8. 이륜차에 물건을 적재 시 편하중·떨어짐 방지조치를 실시한다.",
        isChecked: "",
      },
      {
        content: "9. 날씨에 따른 운행 시 주의사항, 위험요인, 감속기준 등을 제시하고 필요시 운행을 제한하는 절차를 가지고 있다.",
        isChecked: "",
      },
      {
        content: "10. 배달종사자에게 배달지역의 지리적 특성(과속방지턱, 급커브 구역 등)과 노면상태에 따른 안전운행 방법을 교육한다.",
        isChecked: "",
      },
    ],
  },
];
